import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Pagination,
  Autoplay,
  A11y,
} from "swiper/modules";
import Slide from "react-reveal/Slide";
import { IList } from "../../../../utils/generalType";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const testimony: IList[] = [
  {
    title: "Jane Kelechi",
    subTitle: "CEO",
    caption:
      "Implementing SupaRecords Inventory POS transformed how we manage our stock and orders. The real-time tracking and multi-warehouse support have streamlined our operations significantly. Their team's responsiveness and tailored onboarding made adoption effortless. It has become an essential part of our daily operations.",
    image: `${process.env.PUBLIC_URL}/images/testimony/testimony1.png`,
  },
  {
    title: "Tolu Adeyemi",
    subTitle: "Operations Manager",
    caption:
      "We now have complete visibility across all our warehouses. Automated stock alerts, detailed reporting, and the intuitive dashboard have improved our purchasing decisions and reduced stock shortages. The customer support team has been exceptional from day one.",
    image: `${process.env.PUBLIC_URL}/images/testimony/testimony2.png`,
  },
];

const InventoryTestimonyComp = () => {
  return (
    <section className="relative overflow-hidden bg-white py-24">

      {/* Decorative Background */}

      <div className="absolute -left-40 top-0 h-96 w-96 rounded-full bg-red-100 blur-[150px]" />

      <div className="absolute right-0 bottom-0 h-[420px] w-[420px] rounded-full bg-orange-100 blur-[160px]" />

      <div className="relative max-w-7xl mx-auto px-6">

        {/* Heading */}

        <Slide bottom>

          <div className="max-w-3xl mx-auto text-center mb-20">

            <div className="inline-flex items-center gap-2 rounded-full bg-red-50 px-5 py-2">

              <span className="h-2 w-2 rounded-full bg-red-500 animate-pulse" />

              <span className="text-sm font-semibold text-red-600">

                Testimonials

              </span>

            </div>

            <h2 className="mt-8 text-5xl lg:text-6xl font-black leading-tight text-slate-900">

              Trusted By

              <span className="block bg-gradient-to-r from-red-600 via-orange-500 to-yellow-500 bg-clip-text text-transparent">

                Businesses Across Nigeria

              </span>

            </h2>

            <p className="mt-8 text-lg leading-8 text-gray-600">

              Discover why businesses rely on SupaRecords every day to
              simplify inventory management, sales, purchasing,
              accounting and reporting.

            </p>

          </div>

        </Slide>

        <Swiper
          modules={[Navigation, Pagination, Autoplay, A11y]}
          slidesPerView={1}
          navigation
          loop
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          {testimony.map((item, index) => (
            <SwiperSlide key={index}>

              <Slide bottom>

                <div className="max-w-5xl mx-auto">

                  <div className="relative overflow-hidden rounded-[36px] border border-gray-200 bg-white p-8 lg:p-14 shadow-[0_30px_80px_rgba(0,0,0,.08)]">

                    {/* Quote */}

                    <div className="absolute right-10 top-4 text-[140px] font-black leading-none text-red-100">

                      “

                    </div>

                    <div className="grid gap-10 lg:grid-cols-[220px_1fr] items-center">

                      {/* Customer */}

                      <div className="text-center">

                        <img
                          src={item.image}
                          alt={item.title}
                          className="mx-auto h-36 w-36 rounded-full object-cover border-4 border-red-100 shadow-xl grayscale hover:grayscale-0 transition duration-500"
                        />

                        <h3 className="mt-6 text-2xl font-bold text-slate-900">

                          {item.title}

                        </h3>

                        <p className="mt-2 font-semibold text-red-600">

                          {item.subTitle}

                        </p>

                        <div className="mt-6 flex justify-center gap-1 text-yellow-400 text-xl">

                          ★★★★★

                        </div>

                      </div>

                      {/* Testimonial */}

                      <div>

                        <svg
                          className="mb-8 h-12 w-12 text-red-500"
                          fill="currentColor"
                          viewBox="0 0 32 32"
                        >
                          <path d="M10 8C6 8 4 11 4 15c0 4 3 7 7 7 1 0 2-.2 3-.6-1.2 2.4-3.5 4-7 4v2c6 0 11-5 11-12 0-5-3-8-8-8zm14 0c-4 0-6 3-6 7 0 4 3 7 7 7 1 0 2-.2 3-.6-1.2 2.4-3.5 4-7 4v2c6 0 11-5 11-12 0-5-3-8-8-8z" />
                        </svg>

                        <p className="text-xl leading-10 italic text-gray-600">

                          "{item.caption}"

                        </p>

                      </div>

                    </div>

                  </div>

                </div>

              </Slide>

            </SwiperSlide>
          ))}
        </Swiper>

        {/* Bottom Stats */}

        <Slide bottom>

          <div className="mt-20 rounded-[36px] bg-gradient-to-r from-red-600 via-red-500 to-orange-500 p-10 text-white">

            <div className="grid gap-10 text-center md:grid-cols-4">

              <div>

                <h3 className="text-5xl font-black">
                  500+
                </h3>

                <p className="mt-2 opacity-90">
                  Happy Businesses
                </p>

              </div>

              <div>

                <h3 className="text-5xl font-black">
                  99%
                </h3>

                <p className="mt-2 opacity-90">
                  Customer Satisfaction
                </p>

              </div>

              <div>

                <h3 className="text-5xl font-black">
                  24/7
                </h3>

                <p className="mt-2 opacity-90">
                  Technical Support
                </p>

              </div>

              <div>

                <h3 className="text-5xl font-black">
                  99.9%
                </h3>

                <p className="mt-2 opacity-90">
                  Cloud Uptime
                </p>

              </div>

            </div>

          </div>

        </Slide>

      </div>
    </section>
  );
};

export default InventoryTestimonyComp;